import { render, staticRenderFns } from "./ReportRender.vue?vue&type=template&id=64eb95fb&scoped=true&lang=html&"
import script from "./ReportRender.vue?vue&type=script&lang=js&"
export * from "./ReportRender.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64eb95fb",
  null
  
)

export default component.exports